import { api } from './http'

export function getPublishedArticles(page = 1, size = 10, tagID = 0, keyword = '') {
  return api.get('/front/articles', {
    params: { page, size, tag_id: tagID, keyword }
  })
}

export function getArticleDetail(id) {
  return api.get(`/front/articles/${id}`)
}

// export function likeArticle(id) { // 点赞功能已禁用
//   return api.post(`/front/articles/${id}/like`)
// }

// 管理员文章 API
export function getAdminArticles(page = 1, size = 10, keyword = '', status = '') {
  return api.get('/admin/articles', { params: { page, size, key_word: keyword, status } })
}

export function getAdminArticle(id) {
  return api.get(`/admin/articles/${id}`)
}

export function createArticle(articleData) {
  return api.post('/admin/articles', articleData)
}

export function updateArticle(id, articleData) {
  return api.put(`/admin/articles/${id}`, articleData)
}

export function deleteArticle(id) {
  return api.delete(`/admin/articles/${id}`)
}

export function getArticleStats() {
  return api.get('/admin/articles/stats')
}
